import { all, call, fork, put, takeEvery } from "redux-saga/effects";
import {
  FETCH_BOOK_PERFORMANCE_PUBLISHERS,
  FETCH_BOOK_PERFORMANCE,
  FETCH_BOOK_PERFORMANCE_TREND,
  FETCH_BOOK_PERFORMANCE_DETAIL,
  EXPORT_BOOK_PERFORMANCE_CSV,
  FETCH_BOOK_PERFORMANCE_AUTHORS,
  FETCH_AUTHOR_BOOK_PERFORMANCE,
  FETCH_AUTHOR_BOOK_PERFORMANCE_TREND,
} from "../ActionTypes";
import {
  getBookPerformancePublishers,
  getBookPerformance,
  getBookPerformanceTrend,
  getBookPerformanceDetail,
  downloadBookPerformanceCsv,
  getBookPerformanceAuthors,
  getAuthorBookPerformance,
  getAuthorBookPerformanceTrend,
} from "../Api";
import {
  fetchBookPerformancePublishersSuccess,
  fetchBookPerformancePublishersFailure,
  fetchBookPerformanceSuccess,
  fetchBookPerformanceFailure,
  fetchBookPerformanceTrendSuccess,
  fetchBookPerformanceTrendFailure,
  fetchBookPerformanceDetailSuccess,
  fetchBookPerformanceDetailFailure,
  exportBookPerformanceCsvSuccess,
  exportBookPerformanceCsvFailure,
  fetchBookPerformanceAuthorsSuccess,
  fetchBookPerformanceAuthorsFailure,
  fetchAuthorBookPerformanceSuccess,
  fetchAuthorBookPerformanceFailure,
  fetchAuthorBookPerformanceTrendSuccess,
  fetchAuthorBookPerformanceTrendFailure,
} from "../Actions";

const message = (error) => error.response?.data?.message || error.message || "Request failed";
function* run(apiFunction, success, failure, payload) {
  try {
    const response = yield call(apiFunction, payload);
    yield put(success(response));
  } catch (error) {
    yield put(failure(message(error)));
  }
}

function* publishers() {
  yield* run(
    getBookPerformancePublishers,
    fetchBookPerformancePublishersSuccess,
    fetchBookPerformancePublishersFailure
  );
}
function* monthly({ payload }) {
  yield* run(getBookPerformance, fetchBookPerformanceSuccess, fetchBookPerformanceFailure, payload);
}
function* trend({ payload }) {
  yield* run(
    getBookPerformanceTrend,
    fetchBookPerformanceTrendSuccess,
    fetchBookPerformanceTrendFailure,
    payload
  );
}
function* detail({ payload }) {
  yield* run(
    getBookPerformanceDetail,
    fetchBookPerformanceDetailSuccess,
    fetchBookPerformanceDetailFailure,
    payload
  );
}
function* exportCsv({ payload }) {
  yield* run(
    downloadBookPerformanceCsv,
    exportBookPerformanceCsvSuccess,
    exportBookPerformanceCsvFailure,
    payload
  );
}
function* authors({ payload }) {
  yield* run(
    getBookPerformanceAuthors,
    fetchBookPerformanceAuthorsSuccess,
    fetchBookPerformanceAuthorsFailure,
    payload
  );
}
function* authorMonthly({ payload }) {
  yield* run(
    getAuthorBookPerformance,
    fetchAuthorBookPerformanceSuccess,
    fetchAuthorBookPerformanceFailure,
    payload
  );
}
function* authorTrend({ payload }) {
  yield* run(
    getAuthorBookPerformanceTrend,
    fetchAuthorBookPerformanceTrendSuccess,
    fetchAuthorBookPerformanceTrendFailure,
    payload
  );
}

export default function* bookPerformanceSagas() {
  yield all([
    fork(function* () {
      yield takeEvery(FETCH_BOOK_PERFORMANCE_PUBLISHERS, publishers);
    }),
    fork(function* () {
      yield takeEvery(FETCH_BOOK_PERFORMANCE, monthly);
    }),
    fork(function* () {
      yield takeEvery(FETCH_BOOK_PERFORMANCE_TREND, trend);
    }),
    fork(function* () {
      yield takeEvery(FETCH_BOOK_PERFORMANCE_DETAIL, detail);
    }),
    fork(function* () {
      yield takeEvery(EXPORT_BOOK_PERFORMANCE_CSV, exportCsv);
    }),
    fork(function* () {
      yield takeEvery(FETCH_BOOK_PERFORMANCE_AUTHORS, authors);
    }),
    fork(function* () {
      yield takeEvery(FETCH_AUTHOR_BOOK_PERFORMANCE, authorMonthly);
    }),
    fork(function* () {
      yield takeEvery(FETCH_AUTHOR_BOOK_PERFORMANCE_TREND, authorTrend);
    }),
  ]);
}
